import { render } from "./JoinCompanyForm.vue?vue&type=template&id=18523c56&scoped=true&ts=true"
import script from "./JoinCompanyForm.vue?vue&type=script&lang=ts"
export * from "./JoinCompanyForm.vue?vue&type=script&lang=ts"

import "./JoinCompanyForm.vue?vue&type=style&index=0&id=18523c56&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18523c56"]])

export default __exports__